import { render, staticRenderFns } from "./price-dialog.vue?vue&type=template&id=71b5bcbc&scoped=true"
import script from "./price-dialog.vue?vue&type=script&lang=js"
export * from "./price-dialog.vue?vue&type=script&lang=js"
import style0 from "./price-dialog.vue?vue&type=style&index=0&id=71b5bcbc&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71b5bcbc",
  null
  
)

export default component.exports